/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPPREMIUMFREQUENCY = {
    Single: '0',
    Annual: '1',
    HalfYearly: '2',
    Quarterly: '4',
    Monthly: '12'
} as const;
export type IAPPREMIUMFREQUENCY = typeof IAPPREMIUMFREQUENCY[keyof typeof IAPPREMIUMFREQUENCY];


export function IAPPREMIUMFREQUENCYFromJSON(json: any): IAPPREMIUMFREQUENCY {
    return IAPPREMIUMFREQUENCYFromJSONTyped(json, false);
}

export function IAPPREMIUMFREQUENCYFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPPREMIUMFREQUENCY {
    return json as IAPPREMIUMFREQUENCY;
}

export function IAPPREMIUMFREQUENCYToJSON(value?: IAPPREMIUMFREQUENCY | null): any {
    return value as any;
}

